import React from 'react';

const TeamSection = () => {
  const teamMembers = [
    {
      name: 'Dr. Philip Alton',
      role: 'Founder & CEO',
      bio: 'Ex-Emergency medicine doctor, NHS England clinical entrepreneur, MSE innovation fellow. 7yrs+ as medical device startup founder, >£3M in venture and grant funding raised.',
      photoUrl: "/images/team/philip-alton.png"
    },
    {
      name: 'Dr. Miguel Hernandez',
      role: 'CTO',
      bio: 'Previously CTO of a Software-as-a-Service startup in the digital health space. Lead software engineer in the NHS and Department of Health and Social Care.',
      photoUrl: "/images/team/miguel-hernandez.png"
    },
    {
      name: 'Kieran Dwyer',
      role: 'Head of Software',
      bio: 'Extensive experience in the UK National Health Service, navigating security and governance requirements in the space.',
      photoUrl: "/images/team/kieran-dwyer.png"
    },
    {
      name: 'Dr. Sundeep Kaul',
      role: 'Chief Medical Officer',
      bio: '25 years in Respiratory medicine and critical care. Ex-Darzi Fellow. Currently at Harefield Hospital.',
      photoUrl: "/images/team/sundeep-kaul.png"
    },
    {
      name: 'Andrew Davidson',
      role: 'Board Advisor',
      bio: 'Experienced technology entrepreneur, founded multiple seed-stage tech companies. Lead and built teams of over 200 people, raised over £20M in finance.',
      photoUrl: "/images/team/andrew-davidson.png"
    },
    {
      name: 'Charlotte Corke',
      role: 'Product Manager',
      bio: '25 years in digital media with experience in business strategy, product development, user experiences, business analysis, project/team management.',
      photoUrl: "/images/team/charlotte-corke.png"
    },
  ];

  const advisors = [
    {
      name: 'Dr. Paul Walker',
      role: 'Medical Advisor',
      bio: 'Respiratory Consultant, Aintree University Hospital. Honorary Senior Lecturer, University of Liverpool.',
      photoUrl: "/images/team/paul-walker.png"
    },
    {
      name: 'Paul Morton',
      role: 'Business Advisor',
      bio: 'Transformational global C-Suite leader with deep experience in MedTech, HealthTech, Healthcare facilities and Health & Social Care services.',
      photoUrl: "/images/team/paul-moreton.png"
    },
    {
      name: 'Jonathan Butters',
      role: 'Design Advisor',
      bio: 'Internationally renowned award-winning design expert. Has made significant contributions to 24 patents through extensive invention.',
      photoUrl: "/images/team/jonathan-butters.png"
    },
  ];

  return (
    <div className="space-y-8">
      <div className="bg-white p-8 rounded-xl shadow-md">
        <h3 className="text-2xl font-bold text-primary mb-8">Leadership Team</h3>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
          {teamMembers.map((member, index) => (
            <div key={index} className="bg-lightgray p-6 rounded-lg flex flex-col items-center">
              <div className="w-32 h-32 bg-gray-300 rounded-full mb-4 flex items-center justify-center text-gray-500 overflow-hidden">
                {member.photoUrl ? (
                  <img 
                    src={member.photoUrl} 
                    alt={member.name} 
                    className="w-full h-full object-cover" 
                  />
                ) : (
                  <span>Photo</span>
                )}
              </div>
              <h3 className="font-semibold text-primary mb-2">{member.name}</h3>
              <p className="text-gray-700 text-sm">{member.role}</p>
              <p className="text-gray-600 text-sm mt-2 text-center">{member.bio}</p>
            </div>
          ))}
        </div>

        <h3 className="text-2xl font-bold text-primary mb-8 mt-12">Advisory Board</h3>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {advisors.map((advisor, index) => (
            <div key={index} className="bg-lightgray p-6 rounded-lg flex flex-col items-center">
              <div className="w-32 h-32 bg-gray-300 rounded-full mb-4 flex items-center justify-center text-gray-500 overflow-hidden">
                {advisor.photoUrl ? (
                  <img 
                    src={advisor.photoUrl} 
                    alt={advisor.name} 
                    className="w-full h-full object-cover" 
                  />
                ) : (
                  <span>Photo</span>
                )}
              </div>
              <h3 className="font-semibold text-primary mb-2">{advisor.name}</h3>
              <p className="text-gray-700 text-sm">{advisor.role}</p>
              <p className="text-gray-600 text-sm mt-2 text-center">{advisor.bio}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="bg-white p-8 rounded-xl shadow-md">
        <h3 className="text-2xl font-bold text-primary mb-6">Venture Support</h3>
        <div className="flex flex-col md:flex-row items-start gap-8">
          <div className="md:w-1/3 flex justify-center items-center">
            <a href="https://www.port-salus.com/" target="_blank" rel="noopener noreferrer" className="block">
              <div className="w-52 h-52 flex items-center justify-center">
                <img src="/images/partners/port-salus-logo.png" alt="Port Salus Venture Builder" className="max-w-full max-h-full object-contain" />
              </div>
            </a>
          </div>
          <div className="md:w-2/3">
            <h4 className="font-semibold text-primary mb-3">Port Salus Venture Builder</h4>
            <p className="text-gray-700 mb-4">
              An extremely experienced team working together with the Senti team since 2020. The venture builder delivers key non-domain specific capability in core business areas including:
            </p>
            <ul className="list-disc pl-5 space-y-2 text-gray-700">
              <li>Product management</li>
              <li>Brand and marketing</li>
              <li>Go to market and commercialization</li>
              <li>Finance and fundraising</li>
              <li>HR and talent acquisition</li>
              <li>Investor relations</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamSection;